// extracted by mini-css-extract-plugin
export default {"buttonContainer":"results_buttonContainer__C7ZYL"};